export default __webpack_public_path__ + "static/media/Microbials.724c410b.gif";